<p class="section-description">
  Composed snapshots of the Backup tab. Pick a scenario to drive the status bar (creating / planning / last successful /
  failed) and the resource table with backup-context pill labels.
</p>

<label class="recovery-screen-picker">
  <span class="recovery-screen-picker-label">Scenario</span>
  <select class="arpio-select" (change)="setBackupScreenScenario($any($event.target).value)">
    @for (group of backupScreenScenarioGroups; track group.group) {
      <optgroup [label]="group.label">
        @for (scenario of group.scenarios; track scenario.key) {
          <option [value]="scenario.key" [selected]="scenario.key === backupScreenScenarioKey">
            {{ scenario.label }}
          </option>
        }
      </optgroup>
    }
  </select>
</label>
<p class="recovery-screen-description">{{ backupScreenActiveScenario.description }}</p>

<showcase-screen-preview
  [flags]="backupScreenActiveScenario.tabBarFlags"
  activeTab="backup"
  ariaLabel="Backup screen preview (read-only)"
>
  <showcase-status-bar [status]="backupScreenStatus"></showcase-status-bar>

  <app-resources-view
    [resources]="backupScreenResources"
    [tabType]="BackupTab"
    [application]="backupScreenApp"
    [loading]="false"
    [statusContext]="StatusContext.BACKUP"
  ></app-resources-view>
</showcase-screen-preview>
